// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Canvas_canvas__3uh42","foreground":"Canvas_foreground__1mtiR","background":"Canvas_background__tVu_G","content":"Canvas_content__2Ni_z"};